// extracted by mini-css-extract-plugin
module.exports = {"initials":"AccountInitials_initials__2kx3-"};